import { render, staticRenderFns } from "./LeaveCreateAssignment.vue?vue&type=template&id=1e0a5184&scoped=true&"
import script from "./LeaveCreateAssignment.vue?vue&type=script&lang=js&"
export * from "./LeaveCreateAssignment.vue?vue&type=script&lang=js&"
import style0 from "./LeaveCreateAssignment.vue?vue&type=style&index=0&id=1e0a5184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a5184",
  null
  
)

export default component.exports